import { createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "header" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"flexCenter\"><div class=\"logo\"></div></div><div class=\"flexCenter\"><div id=\"TitleHolder\"></div></div><div class=\"flexCenter\"><div class=\"logo\"></div></div>", 3)
const _hoisted_5 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_5))
}